import { render } from "./popup-dialog.vue?vue&type=template&id=a968be4e&scoped=true&ts=true"
import script from "./popup-dialog.vue?vue&type=script&lang=ts"
export * from "./popup-dialog.vue?vue&type=script&lang=ts"

import "./popup-dialog.vue?vue&type=style&index=0&id=a968be4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a968be4e"]])

export default __exports__